import React from "react";

import MetaTags from "react-meta-tags";

const Blog = () => {
  return (
    <div>
      <MetaTags>
        <title>Set Title</title>
        <meta
          name="description"
          content="Idatahost is the best web hosting provider"
        />
      </MetaTags>
      <div className="main">
        {/*hero section start*/}
        <section className="ptb-120 gradient-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-7 col-lg-8">
                <div className="hero-content-wrap text-white text-center position-relative">
                  <h1 className="text-white">Latest News & Events</h1>
                  <p className="lead">
                    Web hosting made easy & affordable, choose a fine-tuned web
                    hosting services solution for successful personal and
                    business websites.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*hero section end*/}

        {/*blog grid section start*/}
        <section className="our-blog-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-4">
                <a
                  className="single-blog-article rounded bg-white border d-block mt-4"
                  href="#">
                  <div className="blog-img mb-2">
                    <img
                      src="assets/img/blog/1.jpg"
                      className="rounded-top img-fluid"
                      alt="blog"
                    />
                  </div>
                  <div className="blog-content-wrap p-4">
                    <div className="article-heading">
                      <h3 className="h5 mb-0">
                        Professionally cultivate testing
                      </h3>
                      <span> On 20 Mar, 2020</span>
                    </div>
                    <span className="border-shape my-3"></span>
                    <p>
                      Dramatically envisioneer functionalized catalysts for
                      change without enterprise-wide meta-services.
                    </p>
                    <div className="article-footer d-flex align-items-center justify-content-between">
                      <div className="article-comments">
                        <span>
                          <i className="fas fa-comment mr-1"></i> 34 Comments
                        </span>
                      </div>
                      <div className="article-user">
                        <span className="fas fa-user"></span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-6 col-lg-4">
                <a
                  className="single-blog-article rounded bg-white border d-block mt-4"
                  href="#">
                  <div className="blog-img mb-2">
                    <img
                      src="assets/img/blog/2.jpg"
                      className="rounded-top img-fluid"
                      alt="blog"
                    />
                  </div>
                  <div className="blog-content-wrap p-4">
                    <div className="article-heading">
                      <h3 className="h5 mb-0">Monotonectally promote market</h3>
                      <span> On 20 May, 2020</span>
                    </div>
                    <span className="border-shape my-3"></span>
                    <p>
                      Enthusiastically pursue tactical architectures vis-a-vis
                      goal-oriented resources.
                    </p>
                    <div className="article-footer d-flex align-items-center justify-content-between">
                      <div className="article-comments">
                        <span>
                          <i className="fas fa-comment mr-1"></i> 24 Comments
                        </span>
                      </div>
                      <div className="article-user">
                        <span className="fas fa-user"></span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-6 col-lg-4">
                <a
                  className="single-blog-article rounded bg-white border d-block mt-4"
                  href="#">
                  <div className="blog-img mb-2">
                    <img
                      src="assets/img/blog/3.jpg"
                      className="rounded-top img-fluid"
                      alt="blog"
                    />
                  </div>
                  <div className="blog-content-wrap p-4">
                    <div className="article-heading">
                      <h3 className="h5 mb-0">Seamlessly evolve interactive</h3>
                      <span> On 10 Mar, 2020</span>
                    </div>
                    <span className="border-shape my-3"></span>
                    <p>
                      Enthusiastically pursue tactical architectures vis-a-vis
                      goal-oriented resources.
                    </p>
                    <div className="article-footer d-flex align-items-center justify-content-between">
                      <div className="article-comments">
                        <span>
                          <i className="fas fa-comment mr-1"></i> 20 Comments
                        </span>
                      </div>
                      <div className="article-user">
                        <span className="fas fa-user"></span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-6 col-lg-4">
                <a
                  className="single-blog-article rounded bg-white border d-block mt-4"
                  href="#">
                  <div className="blog-img mb-2">
                    <img
                      src="assets/img/blog/4.jpg"
                      className="rounded-top img-fluid"
                      alt="blog"
                    />
                  </div>
                  <div className="blog-content-wrap p-4">
                    <div className="article-heading">
                      <h3 className="h5 mb-0">Monotonectally promote market</h3>
                      <span> On 20 May, 2020</span>
                    </div>
                    <span className="border-shape my-3"></span>
                    <p>
                      Enthusiastically pursue tactical architectures vis-a-vis
                      goal-oriented resources.
                    </p>
                    <div className="article-footer d-flex align-items-center justify-content-between">
                      <div className="article-comments">
                        <span>
                          <i className="fas fa-comment mr-1"></i> 24 Comments
                        </span>
                      </div>
                      <div className="article-user">
                        <span className="fas fa-user"></span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-6 col-lg-4">
                <a
                  className="single-blog-article rounded bg-white border d-block mt-4"
                  href="#">
                  <div className="blog-img mb-2">
                    <img
                      src="assets/img/blog/5.jpg"
                      className="rounded-top img-fluid"
                      alt="blog"
                    />
                  </div>
                  <div className="blog-content-wrap p-4">
                    <div className="article-heading">
                      <h3 className="h5 mb-0">
                        Professionally cultivate testing
                      </h3>
                      <span> On 20 Mar, 2020</span>
                    </div>
                    <span className="border-shape my-3"></span>
                    <p>
                      Dramatically envisioneer functionalized catalysts for
                      change without enterprise-wide meta-services.
                    </p>
                    <div className="article-footer d-flex align-items-center justify-content-between">
                      <div className="article-comments">
                        <span>
                          <i className="fas fa-comment mr-1"></i> 34 Comments
                        </span>
                      </div>
                      <div className="article-user">
                        <span className="fas fa-user"></span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-md-6 col-lg-4">
                <a
                  className="single-blog-article rounded bg-white border d-block mt-4"
                  href="#">
                  <div className="blog-img mb-2">
                    <img
                      src="assets/img/blog/6.jpg"
                      className="rounded-top img-fluid"
                      alt="blog"
                    />
                  </div>
                  <div className="blog-content-wrap p-4">
                    <div className="article-heading">
                      <h3 className="h5 mb-0">Seamlessly evolve interactive</h3>
                      <span> On 10 Mar, 2020</span>
                    </div>
                    <span className="border-shape my-3"></span>
                    <p>
                      Enthusiastically pursue tactical architectures vis-a-vis
                      goal-oriented resources.
                    </p>
                    <div className="article-footer d-flex align-items-center justify-content-between">
                      <div className="article-comments">
                        <span>
                          <i className="fas fa-comment mr-1"></i> 20 Comments
                        </span>
                      </div>
                      <div className="article-user">
                        <span className="fas fa-user"></span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        {/*blog grid section end*/}
      </div>
    </div>
  );
};

export default Blog;
